import { useLang } from "../context/LangContext";
import { CinematicHero } from "./ui/cinematic-hero";

export default function Hero() {
  const { t, lang } = useLang();

  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <CinematicHero
      key={lang}
      id="home"
      data-testid="hero-section"
      brandName={t.hero.brandName}
      tagline1={t.hero.tagline1}
      tagline2={t.hero.tagline2}
      cardHeading={t.hero.cardHeading}
      cardDescription={t.hero.cardDescription}
      chat={t.hero.chat}
      badges={t.hero.badges}
      speech={t.hero.speech}
      ctaHeading={t.hero.ctaHeading}
      ctaDescription={t.hero.ctaDescription}
      primaryLabel={t.hero.cta1}
      secondaryLabel={t.hero.cta2}
      onPrimaryClick={() => scrollTo("#projects")}
      secondaryHref="https://wa.me/5534998651977"
    />
  );
}
